import { render, staticRenderFns } from "./DialogGohenshin.vue?vue&type=template&id=05ccbee2&scoped=true"
import script from "./DialogGohenshin.vue?vue&type=script&lang=js"
export * from "./DialogGohenshin.vue?vue&type=script&lang=js"
import style0 from "./DialogGohenshin.vue?vue&type=style&index=0&id=05ccbee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ccbee2",
  null
  
)

export default component.exports